import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureFlag, useFeatureFlags } from '../contexts/FeatureFlagsContext';
import { useChat } from '../contexts/ChatContext';
import { useAuth } from '../context/AuthContext';
import { resolveAssistantUiEnabled } from './LaikaChat/resolveAssistantUiEnabled';

/** Ferme le widget chat si l’UI assistant est off ou si l’utilisateur se déconnecte. */
const LaikaChatFlagSync: React.FC = () => {
  useTranslation('common');
  const { isFeatureEnabled } = useFeatureFlags();
  const { isAuthenticated } = useAuth();
  const { closeChat, isChatOpen } = useChat();
  const assistantOn = resolveAssistantUiEnabled({
    featureFlagEnabled: isFeatureEnabled(FeatureFlag.LAIKA),
    forceLaikaEnv: process.env.REACT_APP_FORCE_LAIKA_ENABLED === 'true',
  });

  useEffect(() => {
    if ((!assistantOn || !isAuthenticated) && isChatOpen) {
      closeChat();
    }
  }, [assistantOn, isAuthenticated, isChatOpen, closeChat]);

  return null;
};

export default LaikaChatFlagSync;
